import classNames from "classnames";
import { DateTime } from "luxon";
import React from "react";
import facebookIcon from "../../assets/images/social-facebook.svg";
import instagramIcon from "../../assets/images/social-instagram.svg";
import linkedInIcon from "../../assets/images/social-linkedin.svg";
import twitterIcon from "../../assets/images/social-twitter.svg";
import xingIcon from "../../assets/images/social-xing.svg";
import youTubeIcon from "../../assets/images/social-youtube.svg";
import { SiteSettings } from "../../models/shared/SiteSettings";
import SanityLink, { renderLinkTitle } from "../SanityLink";

interface Props {
  siteSettings: SiteSettings;
}

export const FooterAside = (props: Props) => {
  const { siteSettings } = props;

  return (
    <div className="flex flex-col items-center w-full p-5 bg-brand-primary-20 text-footer-social-text-color md:flex-row md:justify-around">
      {!!siteSettings?.siteContact?.socialMedia && (
        <div className="flex flex-wrap justify-around w-10/12 py-3 md:order-2 md:w-3/12 md:justify-around">
          {!!siteSettings.siteContact.socialMedia.facebook && (
            <a
              href={siteSettings.siteContact.socialMedia.facebook}
              className="text-inherit transition duration-200 hover:text-brand-primary-90"
              title="Facebook"
            >
              <svg width="32" height="32" className="fill-current w-8 h-8">
                <use xlinkHref={facebookIcon.url} />
              </svg>
            </a>
          )}
          {!!siteSettings.siteContact.socialMedia.linkedin && (
            <a
              href={siteSettings.siteContact.socialMedia.linkedin}
              className="text-inherit transition duration-200 hover:text-brand-primary-90"
              title="LinkedIn"
            >
              <svg width="32" height="32" className="fill-current w-8 h-8">
                <use xlinkHref={linkedInIcon.url} />
              </svg>
            </a>
          )}
          {!!siteSettings.siteContact.socialMedia.twitter && (
            <a
              href={siteSettings.siteContact.socialMedia.twitter}
              className="text-inherit transition duration-200 hover:text-brand-primary-90"
              title="Twitter"
            >
              <svg width="32" height="32" className="fill-current w-8 h-8">
                <use xlinkHref={twitterIcon.url} />
              </svg>
            </a>
          )}
          {!!siteSettings.siteContact.socialMedia.youtube && (
            <a
              href={siteSettings.siteContact.socialMedia.youtube}
              className="text-inherit transition duration-200 hover:text-brand-primary-90"
              title="YouTube"
            >
              <svg width="32" height="32" className="fill-current w-8 h-8">
                <use xlinkHref={youTubeIcon.url} />
              </svg>
            </a>
          )}
          {!!siteSettings.siteContact.socialMedia.xing && (
            <a
              href={siteSettings.siteContact.socialMedia.xing}
              className="text-inherit transition duration-200 hover:text-brand-primary-90"
              title="Xing"
            >
              <svg width="32" height="32" className="fill-current w-8 h-8">
                <use xlinkHref={xingIcon.url} />
              </svg>
            </a>
          )}
          {!!siteSettings.siteContact.socialMedia.instagram && (
            <a
              href={siteSettings.siteContact.socialMedia.instagram}
              className="text-inherit transition duration-200 hover:text-brand-primary-90"
              title="Instagram"
            >
              <svg width="32" height="32" className="fill-current w-10 h-10">
                <use xlinkHref={instagramIcon.url} />
              </svg>
            </a>
          )}
        </div>
      )}
      {!!siteSettings?.footer?.policyLinks?.length && (
        <div className="flex flex-wrap justify-around w-10/12 py-3 text-lg underline md:order-3 md:justify-end md:w-4/12">
          {siteSettings.footer.policyLinks.map((link, index) => (
            <SanityLink
              key={index}
              {...link}
              className={classNames(
                index === 0 ? "ml-0" : "ml-4",
                "text-brand-primary-80 transition duration-200 hover:text-brand-primary-90"
              )}
            >
              {renderLinkTitle(link)}
            </SanityLink>
          ))}
        </div>
      )}
      <div className="flex justify-center py-3 md:order-1 md:w-4/12 md:justify-start">
        <span>© Copyright {DateTime.now().toUTC().year} Anticimex</span>
      </div>
    </div>
  );
};
